//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import ApplyList from '../list/ApplyList';
import FavoriteList from '../list/FavoriteList';

export default {
  name: 'Overview',
  components: { ApplyList, FavoriteList },
  computed: {
    ...mapGetters('user', ['userName']),
    isMessageOpen() {
      return process.env.isMessageOpen;
    },
  },
};
